import { ReactNode } from 'react';

import s from './styles.module.scss';

interface ILayoutContainer {
  children: ReactNode;
}

const Container = ({ children, ...props }: ILayoutContainer) => (
  <div id="container" className={s.container} {...props}>
    {children}
  </div>
);

export default Container;
